module.exports = __webpack_public_path__ + "img/integrated_cash.dcc777c5.webp";